var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCountry = function SvgIconCountry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M22 12c0-1.223-.22-2.395-.622-3.478L12 8.087l-9.378.435A10 10 0 0 0 2 12c0 1.224.22 2.395.622 3.479l9.378.435 9.378-.435A10 10 0 0 0 22 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 22c4.3 0 7.965-2.714 9.378-6.522H2.622A10 10 0 0 0 12 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M2.622 8.522h18.756a10.004 10.004 0 0 0-18.756 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 2h20v20H2z"
  })))));
};
export default SvgIconCountry;